<!--  -->
<template>
  <div>
    <van-nav-bar
      :title="$t('Pay.create')"
      left-arrow
      fixed
      @click-left="$router.push('/payList')"
    >
      <van-icon
        name="./static/img/ok.png"
        slot="right"
        @click="storePayment()"
        style="font-size: 24px"
      />
    </van-nav-bar>
    <div class="contentWrapper">
      <van-field
        v-model="payMethods"
        :label="$t('Pay.type')"
        clearable
        is-link
        readonly
        :placeholder="$t('Pay.selectType')"
        @click="showPaymethods = true"
      />
      <!-- 弹出支付方式 -->
      <van-popup v-model="showPaymethods" position="bottom">
        <van-picker
          show-toolbar
          :columns="methods"
          :confirm-button-text="$t('vantText.confirm')"
          :cancel-button-text="$t('vantText.cancel')"
          @cancel="showPaymethods = false"
          @confirm="onConfirmPayMethods"
        />
      </van-popup>
      <van-field
        v-model="clientId"
        :label="$t('Pay.id')"
        clearable
        :placeholder="$t('Pay.inputId')"
      />
      <van-field
        v-model="clientSecret"
        :label="$t('Pay.secret')"
        clearable
        :placeholder="$t('Pay.inputSecret')"
      />
      <van-field
        v-if="wxpayStatus || AlipayStatus || ECpayStatus"
        v-model="clientCode"
        :label="$t('Pay.code')"
        clearable
        :placeholder="$t('Pay.inputCode')"
      />
      <!-- 商户私钥文件 -->
      <van-cell :title="$t('Pay.file')" v-if="wxpayStatus">
        <el-upload
          class="upload-demo"
          action="fakeAction"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :before-remove="beforeRemove"
          multiple
          accept=".pem"
          :auto-upload="false"
          :on-change="fileChange"
          :on-exceed="handleExceed"
          :file-list="fileList"
          :limit="1"
        >
          <el-button size="small" type="primary" @click="submitUpload"
            >点击上传</el-button
          >
        </el-upload>
      </van-cell>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      payMethods: "",
      clientId: "", //应用id
      clientSecret: "", //秘钥
      clientCode: "", //商店代码
      currentFile: "", //商户私钥文件（微信H5支付特有
      fileList: [],
      showPaymethods: false,
      methods: [],
      methodsList: [],
      payment_id: "",
      wxpayStatus: false,
      AlipayStatus: false,
      ECpayStatus: false
    };
  },
  created() {
    this.getpaymentmethod(); //获取支付类型
  },
  methods: {
    handleRemove(file, fileList) {
      console.log(file, fileList, "检测刪除");
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制選擇 1 个文件，本次選擇了 ${
          files.length
        } 个文件，共選擇了 ${files.length + fileList.length} 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`確定移除 ${file.name}？`);
    },
    fileChange(file, fileList) {
      console.log("测试");
      console.log(file.raw);
      console.log(file.name);
      let formData = new FormData();
      formData.append("file", file);
      this.currentFile = fileList[0].raw;
      // todo 非常重要，一定要加file.raw，从浏览器中查看需要使用binary类型，后台才能正确接收
      // this.form.files = this.fileList[0].raw
      // console.log(this.fileList[0].raw)
      // formData.append("name", file.name);
      // uploadWithName(formData).then((res) => {
      //   console.log(res.data, "附件");
      //   this.newfileArr.push(res.data);
      //   this.fileList.push({ name: file.name, url: res.data });
      // });
    },
    submitUpload() {
      let formData = new FormData();

      this.fileList.forEach(d => {
        formData.append("files", d.raw);
      });
    },

    // 支付类型选择
    getpaymentmethod() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/paymentmethod/outside/index"
      })
        .then(res => {
          if (res.data.status == 200) {
            this.methodsList = res.data.data;
            // 中英文适配
            for (var i = 0; i < this.methodsList.length; i++) {
              if (this.$i18n.locale == "en") {
                this.methods.push(this.methodsList[i].name_en);
              } else if (this.$i18n.locale == "zh") {
                this.methods.push(this.methodsList[i].name_cn);
              } else if (this.$i18n.locale == "hk") {
                this.methods.push(this.methodsList[i].name_hk);
              }
            }
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("StaffList.message")
          });
        });
    },
    // 确认支付方式
    onConfirmPayMethods(value, index) {
      this.showPaymethods = false;
      this.payMethods = value;
      this.payment_id = this.methodsList[index].id;
      console.log(value, index, "选择支付方式");
      this.wxpayStatus = this.payment_id == 2 ? true : false; // 如果选择了微信，添加两个参数字符串client_code和文件file
      this.AlipayStatus = this.payment_id == 3 ? true : false; // 如果选择了支付宝，添加参数字符串client_code
      this.ECpayStatus =
        this.radio == "ECpay" || this.radio == "EC Pay" ? true : false; // 如果选择了ECpay，添加参数字符串client_code
    },
    // 支付设置创建
    storePayment() {
      if (this.wxpayStatus || this.AlipayStatus || this.ECpayStatus) {
        // 選擇了微信
        console.log("触发");
        if (
          this.payMethods &&
          this.clientId &&
          this.clientSecret &&
          this.clientCode
        ) {
          console.log("触发1");
          var dataArr = new FormData();
          dataArr.append("store_id", sessionStorage.actShopId);
          dataArr.append("payment_id", this.payment_id);
          dataArr.append("client_id", this.clientId);
          dataArr.append("client_secret", this.clientSecret);
          dataArr.append("client_code", this.clientCode);
          if (this.wxpayStatus) {
            dataArr.append("file", this.currentFile);
          }
          this.$axios({
            method: "post",
            headers: {
              Authorization: "Bearer " + sessionStorage.token,
              "Content-Type": "multipart/form-data"
            },
            url: this.$build + "/api/storepayment/store",
            data: dataArr
          })
            .then(res => {
              if (res.data.status == 200) {
                console.log(res);
                this.$toast({
                  type: "success",
                  message: res.data.message
                });
                var vm = this;
                setTimeout(() => {
                  vm.$router.push("/payList");
                }, 1000);
              } else {
                for (var item in res.data.error) {
                  this.$toast({
                    type: "fail",
                    message: res.data.error[item]
                  });
                }
              }
            })
            .catch(err => {
              this.$toast({
                type: "fail",
                message: this.$t("StaffList.message")
              });
            });
        }
      } else {
        if (this.payMethods && this.clientId && this.clientSecret) {
          this.$axios({
            method: "post",
            headers: {
              Authorization: "Bearer " + sessionStorage.token
            },
            url: this.$build + "/api/storepayment/store",
            data: {
              store_id: sessionStorage.actShopId,
              payment_id: this.payment_id,
              client_id: this.clientId,
              client_secret: this.clientSecret
            }
          })
            .then(res => {
              if (res.data.status == 200) {
                console.log(res);
                this.$toast({
                  type: "success",
                  message: res.data.message
                });
                var vm = this;
                setTimeout(() => {
                  vm.$router.push("/payList");
                }, 1000);
              } else {
                for (var item in res.data.error) {
                  this.$toast({
                    type: "fail",
                    message: res.data.error[item]
                  });
                }
              }
            })
            .catch(err => {
              this.$toast({
                type: "fail",
                message: this.$t("StaffList.message")
              });
            });
        } else {
          this.$toast({
            type: "fail",
            message: this.$t("NewDish.toast")
          });
        }
      }
    }
  }
};
</script>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 24px;
  color: #fff;
}
/deep/ .van-picker__cancel,
/deep/ .van-picker__confirm {
  color: #2f75f7;
}
</style>



// WEBPACK FOOTER //
// src/Pay/CreatPaymethods.vue